<div class="three-dots-menu" mat-icon-button [ngClass]="[color]"
     [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()" aria-label="three dots menu">
  <mat-icon>more_vert</mat-icon>
</div>
<mat-menu #menu="matMenu">
  <ng-content select="[menu]"></ng-content>
</mat-menu>
